<template>
  <!--eslint-disable-->
  <v-dialog persistent v-model="policyDialog" max-width="800px">
    <v-card flat>
      <v-card-text class="py-5">
        <v-row>
          <v-col cols="12" md="3">
            <div>
              <v-img
                width="150"
                height="120"
                class="mx-auto"
                contain
                src="../../../assets/images/small_certificate.png"
              ></v-img>
            </div>
          </v-col>
          <v-col cols="12" md="9">
            <div class="style">
              <v-icon color="warning" class="mr-3">mdi-comment-alert</v-icon>
              <span class="mx-auto">
                Please ensure the uploaded certificates are
                <strong>certified</strong> otherwise the attachments will not be
                considered for approval.
                <br />
                <span class="font-weight-bold">
                  Individuals who can certify Documents for CPSP-K/APS-K
                  Students are the Awarding Bodies/Institutions.
                </span>
                <!-- <ol class="text--black">
                  <li>Commission of Oaths</li>
                  <li>Priests/Pastors</li>
                  <li>Chiefs</li>
                  <li>Human Resource Managers</li>
                  <li>Dean of Studies/ Registrars</li>
                </ol> -->
              </span>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="my-3"
          v-on:click="policyDialogBox = false"
        >
          <v-icon class="mr-2">mdi-thumb-up</v-icon>
          <span>Proceed </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "policyDialogComponent",
  props: { policyDialog: Boolean },
  computed: {
    policyDialogBox: {
      get() {
        return this.policyDialog;
      },
      set(value) {
        this.$emit("close-dialog", value);
      },
    },
  },
};
</script>
